module.exports = __webpack_public_path__ + "img/GH-kyujin-top-002.157689c1.webp";